import { render, staticRenderFns } from "./OpenPurchase.vue?vue&type=template&id=9df7e57a&"
import script from "./OpenPurchase.vue?vue&type=script&lang=js&"
export * from "./OpenPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports